export default __webpack_public_path__ + "static/media/thumb_down_icon.bd1322ff.svg";